const AltLogo = () => {
  return (
    <span style={{ fontWeight: '900', fontSize: '16px', color: '#E9D9E9', fontFamily: 'Montserrat' }}>DigitalTrendingLab</span>
  );
};

export { AltLogo };
